import { Skeleton } from '@/components/ui/skeleton';

/** Route-level Suspense fallback while a lazy page chunk loads. */
export function PageLoader() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-24" aria-busy="true" aria-label="Loading page">
      <Skeleton className="h-10 w-1/3" />
      <Skeleton className="mt-4 h-5 w-2/3" />
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-48 w-full rounded-xl" />
        ))}
      </div>
    </div>
  );
}
